import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownList } from '@cokitchen/cokitchen-components';
import { NotificationIcon } from 'cokitchen-icons';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/Arrow-down.svg';
import NotificationSideModal from './notification-sidemodal';
import { apiService } from 'services/base.service';
import useDashboardContext from 'contexts/dashboard.context';
import { getSimpleDateFormat, handleApiError } from 'utils/functions';
import { NotificationsType } from 'models/notification.model';

const NotificationDropdown = () => {
  const { activeCompany } = useDashboardContext();
  const [loading, setLoading] = useState(false);
  const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const companyId: string = activeCompany?.id;
  const [previewNotification, setPreviewNotification] = useState<NotificationsType[]>([]);
  const toggleNotificationModal = () => {
    setShowNotificationModal(!showNotificationModal);
    setShowNotificationDropdown(false);
  };

  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const endDate = today;

  const fetchNotifications = async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await apiService.get(`company/notification`, {
        params: {
          start_date: startDate,
          end_date: endDate,
          company_id: companyId,
          page: '1'
        }
      });
      setPreviewNotification(res?.data?.data?.results?.splice(0, 3));
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [companyId]);

  const readNotifications = (notificationId: string) => {
    const data = {
      id: notificationId
    };
    const updatedNotificationData = previewNotification?.map((notification) =>
      notification.id === notificationId ? { ...notification, is_read: true } : notification
    );
    setPreviewNotification(updatedNotificationData);
    try {
      apiService.put('company/notification', { data });
    } catch (err) {
      handleApiError(err);
    }
  };

  return (
    <div>
      <Dropdown
        visible={showNotificationDropdown}
        onClickOutside={() => setShowNotificationDropdown(false)}
        content={
          <div
            role='button'
            className='relative cursor-pointer'
            onClick={() => setShowNotificationDropdown(true)}>
            <NotificationIcon className='w-12 h-12 p-[10px] rounded-full  text-gray-10 bg-[#F2F2F3]' />
            {previewNotification.every((item) => !item.is_read) && (
              <div className='w-3 h-3 absolute right-[11.5px] top-[8px] bg-red-5 rounded-full border-2 border-white' />
            )}
          </div>
        }>
        <DropdownList className='min-w-[350px] sm:w-[420px] md:min-w-[500px] max-h-[400px] p-6 space-y-3 overflow-y-hidden '>
          <div>
            <h1 className='text-xl sm:text-2xl font-bold mb-3'>Notifications</h1>
            <p className='text-[#858585] text-xs'>Latest Updates</p>
          </div>
          {loading && <div className='text-[#858585] text-sm my-4 text-center'>Loading ...</div>}

          {previewNotification?.length > 0 ? (
            previewNotification?.map((item, index: number) => (
              <div
                key={index}
                onClick={() => {
                  readNotifications(item.id);
                }}
                className=''>
                <div className='flex justify-between w-full items-center gap-3 p-2 hover:bg-[#F2F2F2] hover:rounded-md cursor-pointer '>
                  <div className='flex gap-3'>
                    <div className='bg-[#F4F1F1] min-w-[28px] h-[26px] rounded-full flex justify-center items-center'>
                      <ArrowDownIcon />
                    </div>
                    <div className='flex flex-col gap-1'>
                      <p className='text-[#595959]'>{item?.message}</p>
                      <p className='text-[#737373] text-[10px]'>
                        {getSimpleDateFormat(item?.created_at)}
                      </p>
                    </div>
                  </div>

                  <div
                    className={`min-w-[10px] h-[10px] bg-[#E60A2B] rounded-full ${
                      item.is_read ? 'bg-[#EDEDEE]' : 'bg-[#E60A2B]'
                    } `}></div>
                </div>
              </div>
            ))
          ) : (
            <div className=' text-sm text-center my-4'>No notifications available</div>
          )}

          {previewNotification.length > 0 && (
            <button
              onClick={toggleNotificationModal}
              className='text-[#363636] bg-[#F0F0F0] w-full h-[41px] rounded-[100px] font-[500]'>
              View More
            </button>
          )}
        </DropdownList>
      </Dropdown>

      {showNotificationModal && (
        <NotificationSideModal show={showNotificationModal} onClose={toggleNotificationModal} />
      )}
    </div>
  );
};

export default NotificationDropdown;
